import React, { useContext } from 'react'

import withView from 'core/components/withView'
import useFetch from 'core/hooks/use-fetch'
import DynamiteList from 'dynamite/components/DynamiteList'
import { GlobalContext } from 'core/contexts/global-context'
import { getPostBackgrounds } from 'core/helpers/wp-data-helpers'

const Dynamite = (props) => {
  const global = useContext(GlobalContext)
  const { loading, error, data } = useFetch('/dynamite', {})

  useFetch('/page/dynamite', {
    onSuccess: (data) => {
      global.setBackground(getPostBackgrounds(data))
    }
  })

  if (error) throw new Error(error.message)
  if (loading) return null

  return (
    <div className={props.className}>
      <DynamiteList items={data} />
    </div>
  )
}

export default withView(Dynamite)
